import { useGlobalStore } from '~/stores/global';
import { _getConstructorData } from '~/api/shopOffers';
import type { ListingsGetCategory } from '~/interfaces/app';
import type { ModelOfferItem } from '~/interfaces/api';

export default async (url: string, isPageSpeedBot = false) => {
  const globalStore = useGlobalStore();
  // const blogStore = useBlogStore();
  // await blogStore.getBlogArticles;
  return await _getConstructorData(url, {
    params: {
      region_id: globalStore.region.id,
      device: globalStore.device || 1,
    },
  })
    .then(async (mainConstructor: ListingsGetCategory) => {
      if (mainConstructor?.cancelToken) return [];
      const mainConstructorItems: ModelOfferItem[] = isPageSpeedBot
        ? mainConstructor.items.slice(0, 3)
        : mainConstructor.items;
      const needContent = mainConstructorItems.reduce(
        (sum: number, el: ModelOfferItem, index: number) => {
          if (el.has_content) return [...sum, [index, el.id]];
          return sum;
        },
        []
      );
      if ((<ModelOfferItem[]>needContent).length) {
        await Promise.allSettled(
          (<ModelOfferItem[]>needContent).map((el) =>
            _getConstructorData(`blocks/${el[1]}/content`, {
              params: {
                region_id: globalStore.region.id,
                device: globalStore.device || 1,
                sem: globalStore.sem || undefined,
              },
            })
              .then((data) => {
                mainConstructor.items[el[0]].items =
                  globalStore.isBot &&
                  mainConstructor.items[el[0]].type === 'offerlist'
                    ? data.items.map((item) => {
                        if (!item.model_id) {
                          item.description = '';
                        }
                        return item;
                      })
                    : data.items;
              })
              .catch(() => {
                mainConstructor.items[el[0]].items = [];
              })
          )
        );
      }
      if (isPageSpeedBot)
        return {
          ...mainConstructor,
          items: mainConstructorItems,
        };
      return mainConstructor;
    })
    .catch((e) => {
      // console.error('getConstructorData error', e, e?.response);
      throw showError({ statusCode: e?.response?.status || 503 });
    });
};
